// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__13fWN","list":"styles_list__2nyK1"};